import { apiClient } from "./client";

/**
 * Clean-architecture users API (UUID identifiers).
 *
 * Server-side: /api/v1/v2/users/*. Used by the admin screens that
 * manage roles and activation; auth (login) stays on /api/v1/auth.
 */

export type UUID = string;

export type UserRoleV2 =
  | "GUEST"
  | "CUSTOMER"
  | "SUPPLIER"
  | "ORGANIZER"
  | "MANAGER_OF_SALES"
  | "MODERATOR"
  | "ADMIN";

export interface UserV2 {
  id: UUID;
  email: string;
  role: UserRoleV2;
  is_active: boolean;
  is_verified: boolean;
  phone: string | null;
  first_name: string | null;
  last_name: string | null;
  company_name: string | null;
  created_at: string;
  updated_at: string | null;
}

export interface ListUsersResponseV2 {
  items: UserV2[];
  total: number;
}

export interface ListUsersParamsV2 {
  role?: UserRoleV2;
  is_active?: boolean;
  is_verified?: boolean;
  search?: string;
  limit?: number;
  offset?: number;
}

const BASE = "/v2/users";

export const UsersV2AdminApi = {
  list: (params?: ListUsersParamsV2) =>
    apiClient.get<ListUsersResponseV2>(`${BASE}/`, { params }),
  getById: (id: UUID) => apiClient.get<UserV2>(`${BASE}/${id}`),
  changeRole: (id: UUID, new_role: UserRoleV2) =>
    apiClient.post<UserV2>(`${BASE}/${id}/role`, { new_role }),
  deactivate: (id: UUID) =>
    apiClient.post<UserV2>(`${BASE}/${id}/deactivate`),
  activate: (id: UUID) => apiClient.post<UserV2>(`${BASE}/${id}/activate`),
};
